import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import { FAIcon } from '../fa-icon/component.js';
import { pickDataAttributes } from '../../utils/pickDataAttributes.js';
var _excluded = ["name", "label", "buttonClass", "tooltip", "tooltipPosition", "iconTooltip", "trigger"];

var InfoTooltip = function InfoTooltip(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$buttonClass = _ref.buttonClass,
      buttonClass = _ref$buttonClass === void 0 ? '' : _ref$buttonClass,
      tooltip = _ref.tooltip,
      _ref$tooltipPosition = _ref.tooltipPosition,
      tooltipPosition = _ref$tooltipPosition === void 0 ? 'left' : _ref$tooltipPosition,
      iconTooltip = _ref.iconTooltip,
      _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? ['hover', 'focus'] : _ref$trigger,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var tooltipClass = iconTooltip && iconTooltip === 'help' ? 'help-tooltip' : 'info-tooltip';
  var iconClass = iconTooltip && iconTooltip === 'help' ? 'circle-question' : 'circle-info';
  var dataAttributes = pickDataAttributes(otherProps, 'info-tooltip'); // Solution I found in https://github.com/react-bootstrap/react-bootstrap/issues/5166 to fix the positioning of the tooltip

  var tooltipContent = function tooltipContent(tooltipProps) {
    return /*#__PURE__*/React.createElement(Tooltip, _extends({
      id: "tooltip-".concat(name)
    }, tooltipProps), tooltip);
  };

  return /*#__PURE__*/React.createElement("span", _extends({
    className: "tooltip-container"
  }, dataAttributes), /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: tooltipPosition,
    trigger: trigger,
    overlay: tooltipContent
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "default",
    className: "".concat(tooltipClass, " ").concat(buttonClass),
    "aria-label": label // Note: aria cannot be described because ID (`tooltip-${name}`) is not always rendered and thus ID does not always exist on page

  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: iconClass
  }))));
};

InfoTooltip.displayName = "InfoTooltip";
export { InfoTooltip };